import * as React from 'react';
export const BaggageContext = React.createContext(null);
const BaggageContextProvider = BaggageContext.Provider;
export default BaggageContextProvider;
